import { Component, OnInit, ViewChild } from '@angular/core';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { finalize } from 'rxjs/operators';
import { DATETIME_FORMAT } from 'src/app/core/constants/date';
import { SystemNotification, SystemNotificationFollowUp } from 'src/app/core/models/system-notification-message';
import { AuthService } from 'src/app/core/services/auth.service';
import { SystemNotificationService } from 'src/app/core/services/system-notification.service';
import { TableConfig } from 'src/app/core/utils/table-config';

@Component({
  selector: 'th-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit {
  isDataLoading = true;
  notifications: SystemNotification[];
  tableConfig = new TableConfig({
    footerHeight: 0,
    limit: Number.MAX_SAFE_INTEGER
  });
  notification: SystemNotification;
  protected readonly dateFormat = DATETIME_FORMAT;

  @ViewChild('table') table: DatatableComponent;

  constructor(
    private authService: AuthService,
    private systemNotificationService: SystemNotificationService
  ) {}

  ngOnInit(): void {
    this.systemNotificationService
      .fetchCurrentNotifications()
      .pipe(finalize(() => (this.isDataLoading = false)))
      .subscribe((data) => this.processNotifications(data));
  }

  notificationRowClass = (row: SystemNotification) => {
    return row.isUnread ? 'highlight-yellow' : '';
  };

  private processNotifications(notifications: SystemNotification[]) {
    const lastReadDate = new Date(this.authService.lastNotificationReadDate);

    notifications.forEach((notification) => this.processNotification(notification, lastReadDate));

    this.notifications = notifications;

    this.notifications.forEach((notification) => {
      if (notification.followUps?.length > 0) {
        setTimeout(() => {
          this.table.rowDetail.toggleExpandRow(notification);
        });
      }
    });

    this.systemNotificationService.clearMessageCount();
  }

  private processNotification(notification: SystemNotification, lastReadDate: Date) {
    this.setIsNewNotification(notification, lastReadDate);

    if (notification.followUps) {
      notification.followUps.forEach((f) => this.setIsNewFollowUp(f, lastReadDate));
    }
  }

  private setIsNewFollowUp(followUp: SystemNotificationFollowUp, lastReadDate: Date) {
    if (!lastReadDate || new Date(followUp.addedDate) > lastReadDate) {
      followUp.isUnread = true;
    }
  }

  private setIsNewNotification(notification: SystemNotification, lastReadDate: Date) {
    if (!lastReadDate || new Date(notification.startTime) > lastReadDate) {
      notification.isUnread = true;
    }
  }
}
